<template>
  <div class="border" :class="{ white: isOpen }">
    <div class="navigation">
      <router-link to="/">
        <img
          class="navigation__logo"
          :src="require('@/assets/dver-logo.svg')"
        />
      </router-link>
      <div class="navigation__menu">
        <div class="navigation__button" @click="isOpen = !isOpen">
          <img v-show="!isOpen" src="@/assets/img/navi_menu.png" />
          <img v-show="isOpen" src="@/assets/img/navi_cancle.png" />
        </div>
      </div>
    </div>
    <nav v-if="isOpen" class="menu" aria-label="navigation">
      <div>
        <div v-show="!isAuth" class="navigation__info login">
          <router-link class="btn btn__outline" to="/users/signin"
            >로그인</router-link
          >
          <router-link class="btn btn__outline" to="/join/intro"
            >회원가입</router-link
          >
        </div>
        <div v-for="item in list" :key="item.path">
          <nav-list
            v-if="item.auth ? isAuth : true"
            :item="item"
            :userType="userType"
          ></nav-list>
        </div>
      </div>
      <div class="mobile__action">
        <div v-show="isAuth" class="navigation__info">
          <div
            class="btn btn__outline"
            @click="
              signout();
              isOpen = false;
            "
          >
            로그아웃
          </div>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import navList from "./navList.vue";

export default {
  components: { navList },
  props: ["list", "isAuth", "userType", "signout"],
  data() {
    return {
      isOpen: false
    };
  },
  watch: {
    isOpen(val) {
      if (val) {
        document.body.classList.add("modal-open");
      } else {
        document.body.classList.remove("modal-open");
      }
    }
  },
  created() {
    const vm = this;
    this.$router.afterEach((to, from) => {
      vm.isOpen = false;
    });
  }
};
</script>

<style scoped>
.border {
  padding: 0px 20px;
  position: relative;
  box-sizing: border-box;
  z-index: 999998;
  display: flex;
  flex-direction: column;
}

.white {
  background-color: var(--white);
  transition: background-color 0.3s ease;
  height: 100vh;
}

.navigation {
  position: relative;
  box-sizing: border-box;
  height: 60px;
  padding-top: 16px;
  padding-bottom: 16px;
  display: flex;
  justify-content: space-between;
}
.navigation__menu {
  display: flex;
  align-items: center;
  gap: 8px;
}
.navigation__info {
  color: var(--gray-description);
  font-size: 14px;
  display: flex;
  gap: 16px;
}

.navigation__info.login {
  margin-bottom: 40px;
  display: flex;
  gap: 10px;
}

.navigation__info.login .btn {
  width: 100%;
}
.navigation__logo {
  cursor: pointer;
}
.navigation__button {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.navigation__button img {
  width: 24px;
  height: 24px;
}

.menu {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding: 40px 20px 200px;
  z-index: 999997;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow-y: auto;
  box-sizing: border-box;
  border-top: 1px solid var(--gray-200);
}

.mobile__action {
  margin-top: 8px;
}

.btn {
  width: 100%;
  height: 40px;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--gray-600);
  border-radius: 999px;
  cursor: pointer;
}

.btn__outline {
  border: 1px solid var(--gray-300);
  background-color: var(--white);
}

.btn__gray {
  background-color: var(--gray-100);
}
</style>
